import { BUTTON_PRESS } from './baseEvents'

const AI_INCIDENT_SUMMARY = 'AI Incident Summary'

export const AI_INCIDENT_SUMMARY_BUTTON_PRESS = `${BUTTON_PRESS} ${AI_INCIDENT_SUMMARY}`
